module.exports = __webpack_public_path__ + "static/media/206-weddings.3ff6c0df.jpg";